import { EventEmitter } from '@flatbiz/utils';

export interface MenuPubSubMap {
  changeMenuBadge: {
    menuLink: string;
    badgeCount: number;
  }[];
}

type IframeMainEvent = keyof MenuPubSubMap;

const eventEmitter = new EventEmitter<MenuPubSubMap>();

export const menuPubSub = {
  /** 发布 */
  publish<K extends IframeMainEvent>(event: K, data: MenuPubSubMap[K]) {
    eventEmitter.publish<IframeMainEvent>(event, data);
  },

  /** 订阅 */
  subscribe<K extends IframeMainEvent>(
    event: K,
    callback: (data: MenuPubSubMap[K]) => void
  ) {
    eventEmitter.subscribe(event, callback);
  },

  /** 取消订阅 */
  unsubscribe<K extends IframeMainEvent>(
    event: K,
    callback: (data: MenuPubSubMap[K]) => void
  ) {
    eventEmitter.subscribe(event, callback);
  },
};
